<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $tc("signageurl", 1) }}</div>
      <router-link
        v-if="$can('create', 'Signages URL')"
        class="btn-blue"
        to="add-signage-url"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          v-if="selectedCinemaId"
          :onSelect="
            (filterIsActive) => {
              filter_is_active = filterIsActive;
              getSignageUrlDetails(selectedCinemaId);
            }
          "
        />

        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.Cinema && selected.Cinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selected.Cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  @click="onSelectHandler('cinema', cinema)"
                  name="cinema"
                  id="cinema"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('cinemaSignageURL')" /> -->
            </div>
            <p class="error_message"></p>
          </div>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'su_signage_url'"
                @click="onSortValue('su_signage_url', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('su_signage_url', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('su_signage_url', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("signageurl", 1) }}
            </th>
            <!-- <th>{{ $tc('screen', 1) }} {{ $t('name') }}</th> -->
          </tr>
        </thead>
        <tbody v-if="SignageUrlList.length > 0">
          <tr
            v-for="(signageurl, signageurlIndex) in SignageUrlList"
            :key="signageurlIndex"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    signageurl.su_is_active === 'Y' ? 'active' : 'inactive'
                  "
                />

                <i
                  v-if="$can('update', 'Signages URL')"
                  class="edit-pen icon blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="
                    goToRoute('/cinema-manager/edit-signage-url', signageurl)
                  "
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>
                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="onViewSignageUrl(signageurl)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>
              {{ signageurl.su_signage_url }}
              <img
                @click="onCopy(signageurl.su_signage_url)"
                src="@/assets/img/icons/copy_image_icon.png"
                width="15px"
                height="15px"
              />
            </td>
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    signageurl.su_is_active === 'Y'
                      ? 'active'
                      : signageurl.su_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Signages URL')"
                    @click="
                      goToRoute('/cinema-manager/edit-signage-url', signageurl)
                    "
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewSignageUrl(signageurl)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
          </tr>
        </tbody>
        <tbody v-else-if="SignageUrlList.length == 0 && NoRecordsFound">
          <tr>
            <td colspan="2">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import signageServices from "@/services/signageService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filter_is_active: "Y",
      gridView: false,
      listView: true,
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      NoRecordsFound: false,
      selected: {
        Cinema: "",
      },
      selectedCinemaId: "",
      Cinemas: [],
      SignageUrlList: [],
      CinemasCopy: [],
      searchCinema: "",
      isRoleID: true,
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }

    this.getCinemasList(obj);
    this.getviewingnumber();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.getSignageUrlDetails(CinemaObj.cine_id);
      this.selectedCinemaId = CinemaObj.cine_id;
      this.selected.Cinema = CinemaObj.cine_name;
    }
  },
  methods: {
    goToRoute: function (path, { su_id }) {
      this.$router.push({
        path: path,
        query: {
          id: su_id,
        },
      });
    },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getSignageUrlDetails(this.selectedCinemaId);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getSignageUrlDetails(this.selectedCinemaId);
      } else {
        this.currentPage = event;
        this.getSignageUrlDetails(this.selectedCinemaId);
      }
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };

                this.onSelectHandler("cinema", cinema);
              }
            });
          } else {
            // Show Errors
            this.$toasted.show(data.message);
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onViewSignageUrl: function (signageurl) {
      this.$router.push({
        path: "view-signage-url",
        query: { su_id: signageurl.su_id },
      });
    },
    onCopy(url) {
      this.$copyText(url).then((e) => {
        if (e.action === "copy") {
          this.$toasted.show("URL Copied");
        } else {
          this.$toasted.show("URL Can not Copy");
        }
      });
    },
    getSignageUrlDetails: function (cinema_id) {
      let payload = {
        cinema_id: cinema_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        filter_is_active: this.filter_is_active,
      };
      signageServices.viewSignageUrlDetails(payload).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.SignageUrlList = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              if (data.Records.length < 10) {
                this.selectedvalue = data.Records.length;
              }
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.SignageUrlList = [];
            this.NoRecordsFound = true;
            console.log("Error: No Records Found");
          }
          console.log("this.SignageUrlList :", this.SignageUrlList);
        } else {
          this.SignageUrlList = [];
          this.NoRecordsFound = true;
          console.log("Error:", data.message);
        }
      });
    },
    onSelectHandler: function (type, value) {
      if (type == "cinema") {
        console.log("value.cine_id :", value.cine_id);
        this.getSignageUrlDetails(value.cine_id);
        this.selectedCinemaId = value.cine_id;
        this.selected.Cinema = value.cine_name;
        this.searchCinema = "";
        this.onSearchCinema(null);
        this.$store.dispatch("selectDropdownCinema", value);
      }
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SignageUrl/signageUrl.vue